import React from 'react';
import { FadeIn } from './FadeIn';
import { TestimonialCard } from './TestimonialCard';
export function ExtendedTestimonials() {
  const testimonials = [{
    quote: 'Compré un domingo a la noche. El lunes entré a la pileta con el plan exacto de la clase. El Tomo 2 es exactamente lo que necesitaba para mis grupos de nivel inicial. Nunca más improviso.',
    initials: 'VM',
    name: 'Valeria M.',
    location: 'Buenos Aires',
    role: 'INSTRUCTORA DE AQUAGYM EN NATATORIO',
    colorClass: 'bg-aqua-600'
  }, {
    quote: 'El Tomo 4, el de adultos mayores, me cambió todo. El primer mes, alumnas que llevaban tiempo estancadas mejoraron visiblemente su movilidad. Las progresiones son únicas.',
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'PROFE EN GIMNASIO CON PILETA',
    colorClass: 'bg-deepblue-600'
  }, {
    quote: 'El sistema de progresión es único en el mercado. 12 clases listas para usar en cada nivel, con las indicaciones técnicas descriptas paso a paso. Antes tardaba horas armando una sesión. Ahora abro el PDF y en 5 minutos tengo todo listo.',
    initials: 'SF',
    name: 'Sofía F.',
    location: 'Córdoba',
    role: 'INSTRUCTORA GRUPAL E INDIVIDUAL',
    colorClass: 'bg-aqua-500'
  }, {
    quote: 'Las Fichas de Seguimiento del Bono 2 eliminaron mi inseguridad al evaluar a mis alumnas. Ahora sé exactamente en qué están y qué necesitan. Mis clases tienen otro nivel de profesionalismo.',
    initials: 'LP',
    name: 'Luciana P.',
    location: 'Tucumán',
    role: 'PROFE PARTICULAR Y EN NATATORIO',
    colorClass: 'bg-purple-500'
  }, {
    quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión. Las alumnas ahora quieren venir porque siempre hay algo nuevo.',
    initials: 'MG',
    name: 'Marcela G.',
    location: 'Mendoza',
    role: 'INSTRUCTORA DE AQUAGYM ONLINE Y PRESENCIAL',
    colorClass: 'bg-rose-500'
  }, {
    quote: 'El Tomo 6 de gestión me salvó de seguir cobrando lo mismo de siempre. Ahora tengo un sistema profesional visible que me permite justificar mis tarifas. Mi natatorio me reconoce como la instructora más organizada.',
    initials: 'LV',
    name: 'Laura V.',
    location: 'Santa Fe',
    role: 'INSTRUCTORA EN NATATORIO Y PILETA MUNICIPAL',
    colorClass: 'bg-green-600'
  }, {
    quote: 'El Programa de 90 Días del Pack Élite me cambió la cabeza. Nunca había dimensionado el potencial de ofrecer un programa cerrado a mis alumnas. Ahora trabajo con una seguridad que antes no tenía.',
    initials: 'AR',
    name: 'Ana R.',
    location: 'Salta',
    role: 'INSTRUCTORA EN CLUB Y PILETA PRIVADA',
    colorClass: 'bg-yellow-500'
  }];
  return <section className="py-10 md:py-24 bg-slate-50" data-id="element-103">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-104">
        <FadeIn data-id="element-105">
          <div className="text-center mb-6 md:mb-16" data-id="element-106">
            <h2 className="text-2xl md:text-5xl font-display font-black text-deepblue-900 mb-2 md:mb-4" data-id="element-107">
              Lo que dicen los instructores que ya lo usan
            </h2>
            <p className="text-sm md:text-xl text-slate-600" data-id="element-108">
              +300 instructores de aquagym de todo el país ya tienen su Aquagym
              Resuelto™
            </p>
          </div>
        </FadeIn>

        <div className="columns-1 md:columns-2 lg:columns-3 gap-4 md:gap-8 space-y-4 md:space-y-8" data-id="element-109">
          {testimonials.map((t, i) => <div key={i} className="break-inside-avoid" data-id="element-110">
              <FadeIn delay={i * 0.1} data-id="element-111">
                <TestimonialCard {...t} data-id="element-112" />
              </FadeIn>
            </div>)}
        </div>
      </div>
    </section>;
}